import { Map as ImmutableMap, List, fromJS } from 'immutable';

const updateImmutableData = (key, state, data) => {
  const currentData = state.get(key);
  if (List.isList(currentData)) {
    const immutableData = fromJS(data);
    return currentData.equals(immutableData)
      ? state
      : state.set(key, immutableData);
  }
  if (ImmutableMap.isMap(currentData)) {
    const immutableData = fromJS(data);
    return currentData.equals(immutableData)
      ? state
      : state.set(key, immutableData);
  }
  return currentData === data ? state : state.set(key, data);
};

export default updateImmutableData;
